import { types, flow, applySnapshot } from "mobx-state-tree";

const Measurement = types.model({
  t: types.optional(types.number, 0),
  v: types.maybeNull(types.number)
});

const MeasurementStore = types
  .model({
    measurements: types.map(Measurement)
  })
  .actions(self => ({
    reset: flow(function* reset() {
      applySnapshot(self, {});
      yield Promise.resolve();
    })
  }));

export { Measurement, MeasurementStore };
